(() => {
  const duration = { days: 86400, hours: 3600, minutes: 60, seconds: 1 };
  function remaining(target, now) {
    let seconds = Math.max(0, Math.ceil((target - now) / 1000));
    const values = {};
    for (const [unit, size] of Object.entries(duration)) {
      values[unit] = Math.floor(seconds / size);
      seconds %= size;
    }
    return values;
  }
  if (typeof module === 'object' && module.exports) module.exports = { remaining };
  if (typeof document === 'undefined') return;
  function mount(root) {
    if (root.dataset.countdownReady) return;
    root.dataset.countdownReady = 'true';
    const target = Date.parse(root.dataset.target), clock = root.querySelector('[role=timer]'), greeting = root.querySelector('.dyd-xmas__greeting'), control = root.querySelector('.dyd-xmas__motion'), media = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = false, visible = false, interval = null;
    const fields = [...root.querySelectorAll('[data-unit]')];
    function tick() {
      if (!Number.isFinite(target)) { clock.hidden = true; return; }
      const now = Date.now(), values = remaining(target, now);
      clock.hidden = now >= target;
      greeting.hidden = now < target;
      for (const field of fields) {
        const value = String(values[field.dataset.unit]).padStart(2, '0');
        if (field.textContent !== value) {
          field.textContent = value;
          field.classList.remove('is-changed');
          requestAnimationFrame(() => { if (root.isConnected) field.classList.add('is-changed'); });
        }
      }
    }
    function sync() {
      const running = visible && !document.hidden;
      root.classList.toggle('is-moving', running && !paused && !media.matches);
      root.classList.toggle('is-reduced', media.matches);
      control.hidden = media.matches;
      control.textContent = paused ? control.dataset.playLabel : control.dataset.pauseLabel;
      control.setAttribute('aria-pressed', String(paused));
      if (running && interval === null) { tick(); interval = setInterval(tick, 1000); }
      if (!running && interval !== null) { clearInterval(interval); interval = null; }
    }
    const onToggle = () => { paused = !paused; sync(); };
    control.addEventListener('click', onToggle);
    media.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0 });
    observer.observe(root);
    tick(); sync();
    root.countdownDestroy = () => { observer.disconnect(); clearInterval(interval); media.removeEventListener('change', sync); document.removeEventListener('visibilitychange', sync); control.removeEventListener('click', onToggle); delete root.dataset.countdownReady; };
  }
  function scan(scope) { if (scope.matches?.('[data-christmas-countdown]')) mount(scope); scope.querySelectorAll('[data-christmas-countdown]').forEach(mount); }
  scan(document);
  if (!window.dydChristmasCountdownEditorBound) {
    window.dydChristmasCountdownEditorBound = true;
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-christmas-countdown]').forEach(root => root.countdownDestroy?.()));
  }
})();
